const calculateAge = (birthdate, givenDate) => {
  if (!birthdate || !givenDate) return null;

  // Birthdate should come from <input type="date" /> → "YYYY-MM-DD"
  if (birthdate.length !== 10) {
    // Still typing / incomplete date like "2012-0" → treat as invalid for now
    return null;
  }

  // Force local midnight to avoid timezone off-by-one weirdness
  const birth = new Date(birthdate + "T00:00:00");
  const event = new Date(givenDate); // can be "January 3, 2026" or "2026-01-03"

  if (Number.isNaN(birth.getTime()) || Number.isNaN(event.getTime())) {
    return null;
  }

  let age = event.getFullYear() - birth.getFullYear();
  const m = event.getMonth() - birth.getMonth();

  if (m < 0 || (m === 0 && event.getDate() < birth.getDate())) {
    age--;
  }

  // Sanity guard: ignore crazy ages
  if (age < 0 || age > 120) return null;

  return age;
};

const isPastDate = (dateString) => {
  const date = new Date(dateString);
  return date < new Date();
};

export { calculateAge, isPastDate };
